// ════════════════════════════════════════════════════════════════════════
//  Einstellungen einer Klasse
//
//  Bisher standen die Lehrgänge als dritte Karte unter der Codeliste. Das las
//  sich, als gehörten sie zu den Kärtchen – dabei ist es der Vorgang, der
//  entscheidet, WAS die Klasse überhaupt übt. Er hat jetzt eine eigene Adresse
//  und einen eigenen Weg aus der Klassenübersicht.
//
//  Eine Seite mit einem Bereich sieht nach zu wenig aus. Sie ist es nicht: die
//  Lehrgangswahl ist die folgenreichste Einstellung der Klasse, und der Ort ist
//  vorbereitet für das, was dazukommt (Schuljahr, Umbenennen, Archivieren).
// ════════════════════════════════════════════════════════════════════════

import { Link, useParams } from "react-router-dom";
import { useSession } from "@otto/plattform";
import { useClass } from "../../classes/lib/data.js";
import { ClassCourses } from "./ClassCourses.js";
import styles from "../../../shared/components/shell.module.css";

export function ClassSettings() {
  const { classId = "" } = useParams();
  const { client } = useSession();
  const schoolClass = useClass(client, classId);

  return (
    <>
      <div className={styles.card}>
        <p className={styles.subtitle} style={{ marginBottom: 10 }}>
          <Link to="/classes">← Klassen</Link>
        </p>
        <h1 className={styles.title}>
          Einstellungen{" "}
          {schoolClass.data
            ? `· ${schoolClass.data.name} · ${schoolClass.data.school_year}`
            : ""}
        </h1>
        <p className={styles.subtitle}>
          Welche Lehrgänge diese Klasse übt und auf welcher Fassung. Was die Kinder sehen,
          hängt an dieser Seite – die Codes und die Ergebnisse zeigen nur, was hier
          eingerichtet ist.
        </p>
      </div>

      <ClassCourses classId={classId} />
    </>
  );
}
